import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagosComponent } from './modules/pagos/components/pagos/pagos.component';

const routes: Routes = [
  {
    path: "etiquetas",
    loadChildren: () => import('src/app/modules/admin/modules/cartera/modules/etiquetas-gestion/etiquetas-gestion.module').then(m => m.EtiquetasGestionModule),
  },
  {
    path: "reportes",
    loadChildren: () => import('src/app/modules/admin/modules/cartera/modules/reportes/reportes.module').then(m => m.ReportesModule),
  },
  {
    path: "cargue",
    loadChildren: () => import('src/app/modules/admin/modules/cartera/modules/cargue/cargue.module').then(m => m.CargueModule),
  },
  {
    path: "simulador",
    loadChildren: () => import('src/app/modules/admin/modules/cartera/modules/simulador/simulador.module').then(m => m.SimuladorModule),
  },
  {
    path: "castigos",
    loadChildren: () => import('src/app/modules/admin/modules/cartera/modules/castigos/castigos.module').then(m => m.CastigosModule),
  },
  {
    path: "acuerdo-pago",
    loadChildren: () => import('src/app/modules/admin/modules/cartera/modules/acuerdo-pago/acuerdo-pago.module').then(m => m.AcuerdoPagoModule)
  },
  {
    path: "garantias-fiduciarias",
    loadChildren: () => import('src/app/modules/admin/modules/cartera/modules/garantias-fiduciarias/garantias-fiduciarias.module').then(m => m.GarantiasFiduciariasModule)
  },
  {
    path: "pagos",
    loadChildren: () => import('src/app/modules/admin/modules/cartera/modules/pagos/pagos.module').then(m => m.PagosModule)
  },
  {
    path: "operaciones-canceladas",
    loadChildren: () => import('src/app/modules/admin/modules/cartera/modules/operaciones-canceladas/operaciones-canceladas.module').then(m => m.OperacionesCanceladasModule)

  },
  {
    path: "cajeros",
    loadChildren: () => import('src/app/modules/admin/modules/cartera/modules/cajeros/cajeros.module').then(m => m.CajerosModule)

  },
  {
    path: "rediferidos",
    loadChildren: () => import('src/app/modules/admin/modules/cartera/modules/rediferidos/rediferidos.module').then(m => m.RediferidosModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes),],
  exports: [RouterModule]
})
export class CarteraRoutingModule { }
